import { PopoverControlButton, Tooltip } from '@audio-network/componentlibrary'
import clsx from 'clsx'

import Link, { type LinkProps } from '@/components/shared/Link'

import sidebarStyles from '../Sidebar.module.css'
import styles from './SidebarNavItem.module.css'
import { SidebarNavItemProps } from './SidebarNavItem.types'

const SidebarNavItem = ({
	startIcon,
	content,
	href,
	onClick,
	popovertarget,
	className,
	...props
}: SidebarNavItemProps): JSX.Element => {
	const children = (
		<>
			<span
				className={clsx(styles.hoverState, sidebarStyles.showWhenExpanded)}
			></span>
			<span className={styles.icon}>{startIcon}</span>
			<span className={clsx(styles.content, sidebarStyles.showWhenExpanded)}>
				{content}
			</span>
		</>
	)

	return (
		<Tooltip content={content}>
			{popovertarget ? (
				<PopoverControlButton
					className={clsx(styles.navItem, className)}
					onClick={onClick}
					popovertarget={popovertarget}
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					{...(props as any)}
				>
					{children}
				</PopoverControlButton>
			) : (
				<Link
					className={clsx(styles.navItem, className)}
					onClick={onClick}
					href={href}
					{...(props as unknown as LinkProps)}
				>
					{children}
				</Link>
			)}
		</Tooltip>
	)
}

export default SidebarNavItem
